export const environment = {
  tier: 'PROD',
  production: true,
  useEmulators: false,
  useFunctionsEmulatorOnly: false,
  disableCookieBanner: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC5i1KsjXohOcfCah0rUPXgOZi9NyWTM2s',
    authDomain: 'awo-care.firebaseapp.com',
    projectId: 'awo-care',
    storageBucket: 'awo-care.firebasestorage.app',
    messagingSenderId: '916102094521',
    // Default appId (customer-ui) - can be overridden per app
    appId: '1:916102094521:web:b5bc5be388c4f7fa8ac568',
    measurementId: 'G-ML9GL99F71',
  },
  // App-specific App IDs for Firebase App Check
  appIds: {
    customerUi: '1:916102094521:web:b5bc5be388c4f7fa8ac568',
    employeeUi: '1:916102094521:web:44968737c41f4c848ac568',
    website: '1:916102094521:web:a88c07854ec5e42c8ac568',
  },
  // App-specific Measurement IDs for Google Analytics
  measurementIds: {
    customerUi: 'G-ML9GL99F71', // TODO: Get correct ID from Firebase Console
    employeeUi: 'G-WKZ7P2PP1S', // TODO: Get from Firebase Console
    website: 'G-XNFLX39H7Z', // TODO: Verify this is correct for website
  },
  googleMapsAPIKey: 'AIzaSyAwR2CCpirGqq1gyvTFSkovadg8VKHFY8c',
  recaptchaSiteKey: '6Lf3MIgqAAAAAIDDzXOLvTbYif3a7HiSp0GbJyOX',
  microsoftTenantId: '8ef6f487-81f8-449b-85ab-5ec65b8ad8de',
  enableAppCheck: true,
  enablePerformance: true,
  companyDomain: 'awo-hs.org',
  // „Meine Anfragen“ (#1175): Ticket-Portal im CRM, prüft den ID-Token.
  ticketPortalUrl: 'https://europe-west3-sg-crm-it-consulting.cloudfunctions.net/ticketPortal',
  appUrls: {
    website: 'https://awo-care.org',
    portal: 'https://app.awo-care.org',
  },
};
